<template>
    <a-card
        :bordered="false" 
        class="header-solid h-full" 
    >
        <!-- style="background-color: #ebeced;" -->
        <template #title>
            <div style="display:flex; flex-direction: row;">   
                <a-avatar
                    :size="64"
                    shape="square"
                    src="/images/company-default.png"
                />
                
                <div class="mt-10  ml-10">
                    <h6 class="font-semibold">{{ $t('form-label.project')}} : {{ data.title }}</h6>
                    <p style="font-weight: 600;">{{ $t('form-label.project-start-date')}} :  {{ data.startDate }} </p>
                    <p style="font-weight: 600;">{{ $t('form-label.project-end-date')}} :  {{ data.endDate }} </p>
                    <p style="font-weight: 600;">{{ $t('form-label.description')}} :  {{ data.description }} </p>
                </div>
            </div>
        </template>
        <template #extra>
            <div class="ant-row-flex ant-row-flex-middle" style="margin: -12px;">
                <div class="ant-col ml-10" style="padding: 12px;">
                    <a-avatar
                        :size="74"
                        shape="square"
                        :src="attachmentUrl"
                        @click="onImageClick(attachmentUrl)"
                    />
                    <h6 class="font-semibold text-md mb-10">{{ $t('form-label.documents') }}</h6>
                </div>
            </div>
        </template>
        <hr style="margin: 18px 0;border: none;height: 1px;background-color: #f5f5f5;background-image: linear-gradient(90deg,transparent,rgba(0,0,0,.4),transparent);opacity: .25;">
        <CoolLightBox 
            :items="images" 
            :index="index"
            @close="index = null">
        </CoolLightBox>
    </a-card>
</template>

<script>
import CoolLightBox from 'vue-cool-lightbox';
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';
export default {
    name: "PreviousWork",
    components:{
        CoolLightBox
    },
    props:{
        data:{
            type: Object,
            required: true
        }
    },
    data() {
        return {
            index: null
        };
    },
    computed:{
        images() {
            let arr = [];
            let img = this.attachmentUrl;
            if (img && img.length > 0 && img.startsWith('http'))
                arr.push(img);
            return arr;
        },
        attachmentUrl(){
            if (this.data && this.data.attachment && this.data.attachment.length > 0){
                return host + this.data.attachment;
            }
            return '/images/default-avatar.png';
        }
    },
    methods:{
        onImageClick(url) {
            let index = this.images.findIndex(e => e == url);
            if (index > -1) {
                this.index = index;
            }
        }
    }
}
</script>

<style>

</style>